import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { OnGetJson, OnGetJsoni } from '../_getjson';
const ByName = "ByName?name=";
const ByCode = "ByCode?code=";
const All = "GetAll?";
// /All , /Code, /Name, /User
const Code = "Code?code=";
const Name = "Name?name=";
const All1 = "All?";
require('../_css/PopUpOther.css');

export default class PopUpOther extends React.Component {
    state = {
        type: this.props.type,
        col: [],
        rows: [],
        valueRetuen: "",
        Htext: "",
        SHtype: 3,
        showSH: '',
        textSearch: "",
        selected: "1",

    }
    componentDidMount() {
        this._loadData(this.state.textSearch, this.state.selected);
    }

    _loadData = (value, by) => {
        let url = ""
        switch (this.props.type) {
            case "searchProduct":
                url = "CSPRODUCT/All?";
                var productset = [];
                OnGetJson(url).then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            productset[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].NAMETH,
                                unit: data[i].STOCKUNIT
                            }
                        }
                    }
                });
                this.setState({ col: productset, Htext: "รายการสินค้า" });
                break;

            case "typeproduct":
                 url = "CSPDSUBGROUP1/";
                if (value !== "" && by === "1") {
                    ////console.log('value!="" && by=="1"');

                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var typeproduct = [];

                OnGetJsoni(url, 'load').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            typeproduct[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }

                        }
                    }
                });

                this.setState({ col: typeproduct, Htext: "ประเภท" });
                break;

            case "brandname":
                url = "CSPDSUBGROUP2/";
                if (value !== "" && by === "1") {
                    ////console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }

                var brandname = [];
                OnGetJsoni(url, 'load').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            brandname[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: brandname, Htext: "ยี่ห้อ" });
                break;

            case "model":
                url = "CSPDSUBGROUP3/";
                if (value !== "" && by === "1") {
                    //console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var model = [];
                OnGetJsoni(url, 'load').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            model[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: model, Htext: "รุ่น" });
                break;

            case "color":
                url = "CSPDSUBGROUP4/";
                if (value !== "" && by === "1") {
                    //console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var color = [];
                OnGetJsoni(url, "load").then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            color[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: color, Htext: "สี" });
                break;

            case "accountgroup":
                url = "CSPRODUCTACCGRP2/";

                if (value !== "" && by === "1") {
                    //console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }

                var accountgroup = [];
                OnGetJsoni(url, "load").then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            accountgroup[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: accountgroup, Htext: "สี" });
                break;

            case "shortname":
                url = "CSDIMENSION1/";
                if (value !== "" && by === "1") {
                    //console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var shortname = [];
                OnGetJsoni(url, "load").then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            shortname[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: shortname, Htext: "ชื่อย่อสินค้า" });
                break;

            case "provincialregister":
                url = "CSDIMENSION2/";

                if (value !== "" && by === "1") {
                    //console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var provincialregister = [];
                OnGetJsoni(url, "load").then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            provincialregister[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: provincialregister, Htext: "ทะเบียนจังหวัด" });
                break;

            case "cash":
                url = "CSDIMENSION4/";
                if (value !== "" && by === "1") {
                    //console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var cash = [];
                OnGetJsoni(url, "load").then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            cash[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: cash, Htext: "เงินสด" });
                break;

            case "arrdata":
            case "arrdataintable":
            case "unitsdefaultreceiving":
            case "unitdefaulpay":
                url = "CSUNIT/";
                if (value !== "" && by === "1") {
                    //console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var arrdata = [];
                OnGetJsoni(url, "load").then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            arrdata[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: arrdata, Htext: "หน่วยนับ" });
                break;

            case "defaultlibrary":
            case "startuppayroll":
            case "warehouse":
            case "defaularchives":
                url = "CSWAREHOUSE/";
                if (value !== "" && by === "1") {
                    ////console.log('value!="" && by=="1"');
                    url += Name + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += Code + value;
                } else if (value === "") {
                    url += All1;
                }

                var arrdata = [];
                OnGetJsoni(url, "load").then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            arrdata[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: arrdata, Htext: "รายการสาขา" });
                break;

            case "location":
            case "getstartedpendleton":
            case "defaulpayposition":
                url = "CSLOCATION/";
                if (value !== "" && by === "1") {
                    ////console.log('value!="" && by=="1"');
                    url += ByName + value;
                    //console.log(url);

                } else if (value !== "" && by === "0") {
                    url += ByCode + value;
                } else if (value === "") {
                    url += All;
                }
                var arrdata = [];
                OnGetJson(url).then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            arrdata[i] = {
                                number: i + 1,
                                code: data[i].CODE,
                                text: data[i].MYNAMETH,
                            }
                        }
                    }
                }
                );
                this.setState({ col: arrdata, Htext: "ที่เก็บ" });
                break;

        }
        setTimeout(() => {
            this.setState({ rows: this.state.col });
        }, 800);
    }
    onSelectRow = (data) => {
        this.setState({ valueRetuen: (data.code) + "|" + (data.text) + "|" + (data.unit) });
        var reData = (data.code) + "|" + (data.text) + "|" + (data.unit);

        setTimeout(() => {
            this.props.Get_PopUpOther(reData);
        }, 100);
    }
    onChangeRadio = (e) => {
        this.setState({ SHtype: e.target.value });
    }
    _onChange = (event) => {
        // console.log(event.target.value);
        this.setState({ textSearch: event.target.value })

    }
    _keyDown = (event) => {
        if (event.key === 'Enter') {
            this._loadData(this.state.textSearch, this.state.selected);
        }
    }
    _onclickSearch() {
        this._loadData(this.state.textSearch, this.state.selected);

    }
    render() {
        const MAX_HEIGHT = 600;
        const ROW_HEIGHT = 20;
        return (
            <div className='popup' style={{ 'z-index': '100' }} >
                <div className='popup_inner divBox'>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-at" > {this.state.Htext} </i></div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>

                    <div class="panel-body divTable" align="right">
                        <div class="form-inline">
                            <div class="form-group mb-2">
                                <input type='radio' id='Choice-1' name='myRadio' value='0'
                                    checked={this.state.selected === '0'} onChange={(e) => this.setState({ selected: e.target.value })} /><span class="choiceSty">รหัส</span>
                                <input type='radio' id='Choice-2' name='myRadio' value='1'
                                    checked={this.state.selected === '1'} onChange={(e) => this.setState({ selected: e.target.value })} /><span class="choiceSty">ชื่อ/คำอธิบาย</span>
                            </div>
                            <div class="form-group">
                                <input id="id1" type="text" class="form-control input-custom" onChange={this._onChange} onKeyDown={this._keyDown} />
                            </div>
                            <span class="input-group-addon-custom" ><i class="fas fa-search f_search" name="searchdata" onClick={this._onclickSearch.bind(this)}></i></span>
                        </div>
                        <br></br>
                        <BootstrapTable
                            data={this.state.rows}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูลที่ค้นหา",
                            }}
                            height="450" >
                            <TableHeaderColumn columnClassName="columnAll? columnNumber" className="columnNumber" dataAlign="center" width="40" dataField='number' isKey> </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="40%" dataField='code' > รหัส </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="50%" dataField='text'  > ชื่อ/คำอธิบาย </TableHeaderColumn>

                        </BootstrapTable>


                    </div>
                    <i id="load"></i>
                </div>
            </div>
        );
    }
}